// extracted by mini-css-extract-plugin
export default {"permission__project-header":"SelectRoleProjects_permission__project-header__CaKrh","permission__dropdown":"SelectRoleProjects_permission__dropdown__PzcTB"};